/* eslint-disable no-console */
import axios from 'axios';
import { BASE_URL } from '../const';

const client = axios.create({
  baseURL: BASE_URL,
  headers: {
    Accept: 'application/json',
  },
  timeout: 60000,
});

// Intercept all requests
client.interceptors.request.use((config) => config, (error) => Promise.reject(error));

// Intercept all responses
client.interceptors.response.use(async (response) => response, (error) => {
  if (error.response?.status === 401) {
    localStorage.removeItem('token');
    window.location.href = '/login';
  }
  if (error.response?.status === 403 && !window.location.href.includes('/login')) {
    // window.history.back();
  }
  return Promise.reject(error);
});

export default async (needsAuth = true) => {
  if (needsAuth) {
    client.defaults.headers.Authorization = `Bearer ${localStorage.getItem('token')}`;
  }
  return client;
};
